/**
 * Experience strategy module index
 * 
 * This file exports all the components and functions from the experience strategy modules.
 */

import { createExperienceStrategy } from './strategy';
import { ExperienceHistogram, ExperienceOptions } from './components';
import { EXPERIENCE_LEVELS } from './constants';
import { 
  createExperienceRanges, 
  extractDefaultExperienceRange, 
  generateHistogramData 
} from './utils';

// Clean confirmation message for session restoration
export const restore_message = "Perfect! I've set the experience range for your search. Let's continue with the next topic.";

// Create and export the experience strategy
const experienceStrategy = createExperienceStrategy();

// Export the components and utility functions
export { 
  ExperienceHistogram, 
  ExperienceOptions,
  EXPERIENCE_LEVELS,
  createExperienceRanges,
  extractDefaultExperienceRange,
  generateHistogramData
};

// Export the strategy as default
export default experienceStrategy;
